import React from "react";
import "./Home2.css";

const Home2 = () => {
  return (
    <div className="h2-div">
      <div className="h2-div1">
        <h2>
          <strong>STRATEGIC</strong> ENGINEERING
        </h2>
      </div>
      <div className="h2-d">
        <div className="h2-div2">
          <h4>Web Product Services</h4>
          <p>
            Our extensive application development services offers the services
            that aid in product creation
          </p>
        </div>
        <div className="h2-div2">
          <h4>Quality Augmentation</h4>
          <p>
            We optimize you existing IT apllications, as well as re-architect
            and re-platform them to make them easier and more innovative
          </p>
        </div>
        <div className="h2-div2">
          <h4>Demonstration And Support or Prototypes</h4>
          <p>
            We offer profound judgment and assist you in maximizing the value of
            your application through support and retain options
          </p>
        </div>
        <div className="h2-div2">
          <h4>Testing Services</h4>
          <p>
            Each stage of the app development process includes functional,
            regression, automated and security testing that is built into the
            process.
          </p>
        </div>
      </div>

      <div className="main-div21">
        <div className="h2-div21">
          <h4 style={{ textAlign: "center", color: "#00BFFF" }}>
            PRODUCTIVE <b>TANLENT</b> MANAGEMENT
          </h4>
        </div>
        <div className="para21">
          <p>
            We are utilizing the global talent revolution, we are opening new
            digital portals{" "}
          </p>
          <p>
            to exploring new possibilities and ideas. We retaining our place in
            the
          </p>
          <p>
            competitive age of the future and moving on from there for the
            future to create{" "}
          </p>
          <p>sustainable digital development for the community</p>
        </div>
        <div className="button">
          <div className="button1">
            <div className="b1">Attaining The Top Talent</div>
            <div className="b1">Performance Management</div>
          </div>
          <div className="button2">
            <div className="b1">Value Based Hiring</div>
            <div className="b1">Succession Planning</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home2;
